/* eslint @typescript-eslint/no-explicit-any: 0 */
/* eslint @typescript-eslint/no-unused-vars: 0 */

import { addMessage, appendToLastMessage, setIsLoading, setMessages } from "./messagesSlice";
import { Socket } from "../../common/utils/Socket";
import { Middleware, nanoid } from "@reduxjs/toolkit";

export const makeSocketMiddleware = (socket: Socket) => {
    const socketMiddleware: Middleware = (params) => (next) => (action) => {
        const { dispatch, getState } = params;
        const { type, payload } = action as { type: string; payload: any };

        function handleSocketOpen(event: Event) {
            console.log("WebSocket connected!");
            dispatch(setIsLoading(false));
        }

        function handleSocketMessage(response: any) {
            const data = JSON.parse(response.data);
            const id = nanoid();
            const sender = data.name as string;

            // Handle different types of events from the WebSocket
            if (data.event === "on_parser_start") {
                // When a new stream starts
                dispatch(addMessage({ id: id, message: "", user: sender }));
            } else if (data.event === "on_parser_stream") {
                // During a stream, appending new chunks of data
                dispatch(appendToLastMessage(data.message));
            } else if (data.event === "on_parser_end") {
                // When a stream ends
                dispatch(setIsLoading(false));
            }
        }

        function handleSocketClose(event: CloseEvent) {
            console.log(`WebSocket is closed now. Code: ${event.code}, Reason: ${event.reason}`);
            dispatch(setIsLoading(true));
        }

        function handleSocketError(event: Event) {
            console.error("WebSocket error observed:", event);
            dispatch(setIsLoading(true));
        }

        switch (type) {
            case "chatbotSocket/connect":
                socket.on("open", handleSocketOpen);
                socket.on("message", handleSocketMessage);
                socket.on("close", handleSocketClose);
                socket.on("error", handleSocketError);
                socket.connect();
                break;

            case "chatbotSocket/disconnect":
                socket.disconnect();
                break;

            case "chatbotSocket/send":
                socket.send({ ...payload, type: "message" });
                dispatch(addMessage(payload));
                dispatch(setIsLoading(true));
                break;

            case "chatbotSocket/reset":
                socket.send({ type: "reset" });
                dispatch(setMessages([]));
                break;

            default:
                break;
        }

        return next(action);
    };

    return socketMiddleware;
};

export function connectSocket() {
    return { type: "chatbotSocket/connect" };
}

export function disconnectSocket() {
    return { type: "chatbotSocket/disconnect" };
}

export function sendMessage(message: string, user: string) {
    return { type: "chatbotSocket/send", payload: { id: nanoid(), message: message, user: user } };
}

export function clearMessageHistory() {
    return { type: "chatbotSocket/reset" };
}
